import React from "react";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";

export function TabelaDemandaContratada(props) {
    return (
        <table width={props.tableWidth}>
            <tbody>
                <tr>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            padding: "2px 5px",
                            textAlign: "center",
                            minWidth: 80,
                            textWrap: "nowrap",
                            fontSize: "0.8rem",
                        }}
                    >
                        Ponta
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            padding: "2px 5px",
                            textAlign: "center",
                            minWidth: 80,
                            textWrap: "nowrap",
                            fontSize: "0.8rem",
                        }}
                    >
                        {adicionarPontosMilhar(props.item.demanda_ponta_contratada_mes_atual) || "-"}
                    </td>
                </tr>
                <tr>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            padding: "2px 5px",
                            textAlign: "center",
                            minWidth: 80,
                            textWrap: "nowrap",
                            fontSize: "0.8rem",
                        }}
                    >
                        Fora Ponta
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            padding: "2px 5px",
                            textAlign: "center",
                            minWidth: 80,
                            textWrap: "nowrap",
                            fontSize: "0.8rem",
                        }}
                    >
                        {adicionarPontosMilhar(props.item.demanda_fora_ponta_contratada_mes_atual) || "-"}
                    </td>
                </tr>
                <tr>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            padding: "2px 5px",
                            textAlign: "center",
                            minWidth: 80,
                            textWrap: "nowrap",
                            fontSize: "0.8rem",
                        }}
                    >
                        Geração
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            padding: "2px 5px",
                            textAlign: "center",
                            minWidth: 80,
                            textWrap: "nowrap",
                            fontSize: "0.8rem",
                        }}
                    >
                        {adicionarPontosMilhar(props.item.demanda_geracao_contratada_mes_atual) || "-"}
                    </td>
                </tr>
            </tbody>
        </table>
    );
}
